import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { NHIEMVUKHAC } from '../constants';
import { Get, DeleteSingle } from '../../utils/httpProvider';
import { NHIEMVUKHAC_API } from '../../utils/apiUrl.js';
import { fetchWithAuth } from '../../utils/httpClient';

// ---------------------------
// helpers
// ---------------------------
const appendIfHasValue = (fd, key, value) => {
  if (value === undefined || value === null) return;
  if (typeof value === 'string' && value.trim() === '') return;
  fd.append(key, value);
};

const buildNhiemVuKhacFormData = ({ data = {}, files = [], removeFileIds = [], isUpdate = false }) => {
  const fd = new FormData();

  appendIfHasValue(fd, 'Title', data.Title);
  appendIfHasValue(fd, 'MoTa', data.MoTa);

  appendIfHasValue(fd, 'MucDo', data.MucDo);

  appendIfHasValue(fd, 'NgayGiao', data.NgayGiao);
  appendIfHasValue(fd, 'HanChot', data.HanChot);
  appendIfHasValue(fd, 'NgayKetThucThucTe', data.NgayKetThucThucTe);

  appendIfHasValue(fd, 'Status', data.Status);

  appendIfHasValue(fd, 'NguoiDungId', data.NguoiDungId);
  appendIfHasValue(fd, 'NhanVienId', data.NhanVienId);

  if (files && files.length) {
    files.forEach((f) => {
      if (f) fd.append('Files', f);
    });
  }

  if (isUpdate && removeFileIds && removeFileIds.length) {
    removeFileIds.forEach((id) => {
      if (id !== undefined && id !== null && id !== '') {
        fd.append('RemoveFileIds', String(id));
      }
    });
  }

  return fd;
};

export const nhiemVuKhacPagingAction = createAsyncThunk(
    NHIEMVUKHAC.GET_ALL_PAGING,
    async (model = {}, { rejectWithValue }) => {
        try {
            const pageIndex = model?.PageIndex ?? model?.pageIndex ?? 1;
            const pageSize = model?.PageSize ?? model?.pageSize ?? 20;
            const keyword = model?.Keyword ?? model?.keyword ?? '';

            const params = new URLSearchParams();
            params.append('Keyword', keyword);
            params.append('PageIndex', pageIndex);
            params.append('PageSize', pageSize);

            const from = model?.From ?? model?.from ?? null;
            const to = model?.To ?? model?.to ?? null;

            const ngayGiaoFrom = model?.NgayGiaoFrom ?? model?.ngayGiaoFrom ?? model?.ngaygiaofrom ?? null;
            const ngayGiaoTo = model?.NgayGiaoTo ?? model?.ngayGiaoTo ?? model?.ngaygiaoto ?? null;

            const mucDo = model?.MucDo ?? model?.mucDo ?? model?.mucdo ?? null;
            const nhanVien = model?.NhanVienId ?? model?.nhanVienId ?? model?.nhanvien ?? null;

            const status = model?.Status ?? model?.status ?? null;

            const nguoiDungId = model?.NguoiDungId ?? model?.nguoiDungId ?? model?.nguoidung ?? null;

            if (from) params.append('From', from);
            if (to) params.append('To', to);

            if (ngayGiaoFrom) params.append('NgayGiaoFrom', ngayGiaoFrom);
            if (ngayGiaoTo) params.append('NgayGiaoTo', ngayGiaoTo);

            if (mucDo !== undefined && mucDo !== null && mucDo !== '') params.append('MucDo', String(mucDo));
            if (nhanVien) params.append('NhanVienId', String(nhanVien));

            if (status !== undefined && status !== null && status !== '') params.append('Status', String(status));
            if (nguoiDungId) params.append('NguoiDungId', String(nguoiDungId));

            const url = `${NHIEMVUKHAC_API.GET_ALL_PAGING}?${params.toString()}`;

            const res = await Get(url);
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);



// get by id
export const nhiemVuKhacGetItemAction = createAsyncThunk(
  NHIEMVUKHAC.GET_BY_ID,
  async (id) => {
    return Get(NHIEMVUKHAC_API.GET_BY_ID(id)).then(res => res).catch(err => err);
  }
);

// create (multipart/form-data)
export const addNhiemVuKhacAction = createAsyncThunk(
  NHIEMVUKHAC.CREATE,
  async (payload, { rejectWithValue }) => {
    try {
      const data = payload?.data ? payload.data : payload;
      const files = payload?.files ? payload.files : [];

      const fd = buildNhiemVuKhacFormData({ data, files, isUpdate: false });

      const res = await fetchWithAuth(NHIEMVUKHAC_API.CREATE, {
        method: 'POST',
        body: fd
      });

      return res?.status ?? 500;
    } catch (err) {
      return rejectWithValue(err?.message || err || 'Create failed');
    }
  }
);

export const editNhiemVuKhacAction = createAsyncThunk(
  NHIEMVUKHAC.UPDATE,
  async (payload, { rejectWithValue }) => {
    try {
      const id = payload?.id;
      if (!id) return rejectWithValue('Missing id');

      const data = payload?.data || {};
      const files = payload?.files || [];
      const removeFileIds = payload?.removeFileIds || [];

      const fd = buildNhiemVuKhacFormData({ data, files, removeFileIds, isUpdate: true });

      const res = await fetchWithAuth(NHIEMVUKHAC_API.UPDATE(id), {
        method: 'PUT',
        body: fd
      });

      return res?.status ?? 500;
    } catch (err) {
      return rejectWithValue(err?.message || err || 'Update failed');
    }
  }
);

// delete
export const deleteNhiemVuKhacAction = createAsyncThunk(
  NHIEMVUKHAC.DELETE,
  async (id, { rejectWithValue, fulfillWithValue }) => {
    return DeleteSingle(NHIEMVUKHAC_API.DELETE(id))
      .then(async res => {
        if (res.status === 200) return fulfillWithValue(res.status);
        return rejectWithValue(await res.json());
      })
      .catch(err => err);
  }
);

export const nhiemVuKhacGetFilesAction = createAsyncThunk(
  NHIEMVUKHAC.GET_FILES_BY_NHIEMVUKHAC,
  async (id, { rejectWithValue }) => {
    if (id === undefined || id === null) {
      return rejectWithValue('Missing id');
    }
    try {
      const url = NHIEMVUKHAC_API.GET_FILES_BY_NHIEMVUKHAC(id);
      const res = await Get(url); 
      return { id, files: res || [] };
    } catch (err) {
      return rejectWithValue(err?.message || err || 'Get files failed');
    }
  }
);

const initialState = {
    listNhiemVuKhac: [],
    totalNhiemVuKhac: 0,
    nhiemVuKhacItem: null,
    filesByNhiemVuKhacId: {},

    // ===== NEW: loading paging list =====
    loadingPaging: false,
    pagingError: null,
    currentPagingRequestId: undefined,
};



export const nhiemVuKhacSlice = createSlice({
  name: NHIEMVUKHAC.NAME_SLICE,
  initialState,
  reducers: {
    filterListNhiemVuKhac: (state, action) => {
      state.listNhiemVuKhac = state.listNhiemVuKhac.filter(x => x.id !== action.payload);
      state.totalNhiemVuKhac = Math.max(0, (state.totalNhiemVuKhac || 0) - 1);
    },
    filterByTrangThaiKhac: (state, action) => {
      const trangThai = action.payload;
      state.listNhiemVuKhac = state.listNhiemVuKhac.filter(x => x.status === trangThai);
    }
  },
    extraReducers: (builder) => {
        builder
            // ===== paging list =====
            .addCase(nhiemVuKhacPagingAction.pending, (state, action) => {
                state.loadingPaging = true;
                state.pagingError = null;
                state.currentPagingRequestId = action.meta.requestId;
            })
            .addCase(nhiemVuKhacPagingAction.fulfilled, (state, action) => {
                if (state.currentPagingRequestId !== action.meta.requestId) return;

                state.loadingPaging = false;
                state.pagingError = null;
                state.currentPagingRequestId = undefined;

                state.listNhiemVuKhac = action.payload?.data || [];
                state.totalNhiemVuKhac = action.payload?.totalRecords || 0;
            })
            .addCase(nhiemVuKhacPagingAction.rejected, (state, action) => {
                if (state.currentPagingRequestId !== action.meta.requestId) return;

                state.loadingPaging = false;
                state.currentPagingRequestId = undefined;
                state.pagingError = action.payload || action.error || null;
            })

            // ===== giữ nguyên các case khác của bạn =====
            .addCase(nhiemVuKhacGetItemAction.fulfilled, (state, action) => {
                state.nhiemVuKhacItem = action.payload;
            })
            .addCase(nhiemVuKhacGetItemAction.rejected, (state) => {
                state.nhiemVuKhacItem = null;
            })
            .addCase(editNhiemVuKhacAction.fulfilled, (state, action) => {
                const arg = action.meta?.arg || {};
                const id = arg.id;
                if (!id) return;
                if (state.filesByNhiemVuKhacId && state.filesByNhiemVuKhacId[id]) {
                    delete state.filesByNhiemVuKhacId[id];
                }
            })
            .addCase(deleteNhiemVuKhacAction.fulfilled, (state, action) => {
                const id = action.meta?.arg;
                if (id === undefined || id === null) return;
                if (state.filesByNhiemVuKhacId && state.filesByNhiemVuKhacId[id]) {
                    delete state.filesByNhiemVuKhacId[id];
                }
            })
            .addCase(nhiemVuKhacGetFilesAction.fulfilled, (state, action) => {
                const { id, files } = action.payload || {};
                if (id === undefined || id === null) return;

                const arr = Array.isArray(files) ? files : (files?.data || []);
                if (!state.filesByNhiemVuKhacId) state.filesByNhiemVuKhacId = {};
                state.filesByNhiemVuKhacId[id] = arr;
            });
    }

});

export const {
  filterListNhiemVuKhac,
  filterByTrangThaiKhac
} = nhiemVuKhacSlice.actions;

export default nhiemVuKhacSlice.reducer;
